//core modules.
import React from "react";
import cx from 'classnames'
//custom modules.
import {useStepsContext} from "./context/stepsContext";
import {randstr} from "../../Common/Appcommon";

const SubscriptionPlans = () => {

    const {
        setPlan,
        currentStep,
        setCurrentStep,
        paymentInfo,
        setPricePerUser,
        subscriptiontype,
        setPlanedMonths,
        offerType,
        paymentDetails
    } = useStepsContext();

    const planBaseAmount = (planAmount, noofusers, noofmonths) => {
        let amount = offerType === "Package" ? ((parseInt(planAmount) * noofusers) * noofmonths) : planAmount;
        return parseInt(amount);
    }
    let userscount = parseInt(paymentInfo[4]);
    let nooftotalusers = parseInt(paymentInfo[18]);
    if(userscount < nooftotalusers){
        userscount = nooftotalusers;
    }
    const monthlyAmount = planBaseAmount(paymentInfo[0], userscount, 1);
    const quarterlyAmount = planBaseAmount(paymentInfo[1], userscount, 3);
    const halfYearAmount = planBaseAmount(paymentInfo[2], userscount, 6);
    const AnnualAmount =  planBaseAmount(paymentInfo[3], userscount, 12);
    let planDesc1 = "/user/month, billed";
    const allPlans = [
        {
            planName : `PAID MONTHLY`,
            currencySymbol : `₹`,
            planAmount : parseInt(paymentInfo[0]),
            amount : monthlyAmount,
            planAmountLabel : monthlyAmount.toLocaleString(),
            planDesc1 : planDesc1 + ` monthly`,
            planDesc2 : `Per month, includes ${userscount} users`,
            planBtnName : `CHOOSE`,
            planType : 'Monthly',
            monthsCount : 1,
            isShow : (monthlyAmount > 0 && monthlyAmount !== "N/A")
        },
        {
            planName : `PAID QUARTERLY`,
            currencySymbol : `₹`,
            planAmount : parseInt(paymentInfo[1]),
            amount : quarterlyAmount,
            planAmountLabel : quarterlyAmount.toLocaleString(),
            planDesc1 : planDesc1 + ` quarterly`,
            planDesc2 : `Per 3 months, includes ${userscount} users`,
            planBtnName : `CHOOSE`,
            planType : 'Quarterly',
            monthsCount : 3,
            isShow : (quarterlyAmount > 0 && quarterlyAmount !== "N/A"),
        },
        {
            planName : `PAID HALF YEARLY`,
            currencySymbol : `₹`,
            planAmount : parseInt(paymentInfo[2]),
            amount : halfYearAmount,
            planAmountLabel : halfYearAmount.toLocaleString(),
            planDesc1 : planDesc1 + ` half yearly`,
            planDesc2 : `Per 6 months, includes ${userscount} users`,
            planBtnName : `CHOOSE`,
            planType : 'Half Yearly',
            monthsCount : 6,
            isShow : (halfYearAmount > 0 && halfYearAmount !== "N/A"),
        },
        {
            planName : `PAID ANNUALLY`,
            currencySymbol : `₹`,
            planAmount : parseInt(paymentInfo[3]),
            amount : AnnualAmount,
            planAmountLabel : AnnualAmount.toLocaleString(),
            planDesc1 : planDesc1 + ` annually`,
            planDesc2 : `Per annum, includes ${userscount} users`,
            planBtnName : `CHOOSE`,
            planType : 'Annually',
            monthsCount : 12,
            isShow : (AnnualAmount > 0 && AnnualAmount !== "N/A"),
        }
    ];

    const plansList = allPlans.filter(plan => plan.isShow);

    const onPlanClick = (plan, planAmount,monthsCount) => {
        setPlan(plan);
        setPricePerUser(planAmount);
        setCurrentStep(currentStep + 1);
        setPlanedMonths(monthsCount);
    }

    const clickBackBtn = (e) => {
        window.location.hash = "#/settings/account/subscription"
    }

    let isHideLeftArrowBtn = false;
    let buyBtnDisabled = subscriptiontype === "upgrade"; //paymentDetails?.items?.modeofpayment;
    
    return (
        <>
            <div className={`back-btn`} onClick={() => clickBackBtn()}>
                <i className={cx(`left-arrow-btn`,{'hide' : isHideLeftArrowBtn})} />
            </div>
            <div className={`plan-top`} />
            <div className={`plan-page-container`}>
                <div className={`plan-selection-container clearfix`}>
                    <div className={`text-center`}>
                        <div className={`plans-container`}>
                            <ul className={`plantypes-list-container`}>
                                {
                                    plansList.map((plan, index)=>{
                                        /* if((customerPaymentType === "Subscription" && plan.planType !== "Monthly")){
                                            return (<></>);
                                        } */
                                        let saveDisCount = Math.floor(((plansList[0].planAmount - plansList[plansList.length - 1].planAmount) / plansList[0].planAmount) * 100);
                                        if(saveDisCount < 0){
                                            saveDisCount = 0;
                                        }
                                        if(buyBtnDisabled){
                                            buyBtnDisabled = (paymentDetails?.items?.modeofpayment !== plansList?.[index-1]?.planType);
                                        }
                                        return (
                                            <li key={randstr('sub_plan_')} className={`plans-info`}>
                                                <div className={`plans-wrapper`}>
                                                    <div className={`plan-price-info`}>
                                                        <div className={cx({"hide" : saveDisCount <= 0})}>
                                                            {
                                                                plansList.length - 1 === index && index !== 0 ? 
                                                                <p className={"subscription-discond-percentage"}>
                                                                    SAVE {saveDisCount}%
                                                                </p>
                                                                :
                                                                <p className="subscription-non-discond">
                                                                    &nbsp;
                                                                </p>
                                                            }
                                                        </div>
                                                        <h2 className={`plan-name`}>{plan.planName}</h2>
                                                        <div className={`plan-price-wrapper`}>
                                                            <span className={`plan-price-symbol`}>{plan.currencySymbol}</span>
                                                            <span className={`plan-price`}>{plan.planAmountLabel}</span>
                                                        </div>
                                                        <div className={`price-info`}>
                                                            {
                                                                offerType === "Package" ? <span>{plan.planDesc2}</span> : <span>{plan.planDesc1}</span>
                                                            }
                                                        </div>
                                                    </div>
                                                    <button onClick={()=>{onPlanClick(plan.planType,plan.planAmount,plan.monthsCount)}} className={`plan-btn`} disabled={buyBtnDisabled} >{plan.planBtnName}</button>
                                                </div>
                                            </li>
                                        );
                                    })
                                }

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default SubscriptionPlans;
